"use client"
import { getPermissionsFromStorage, hasPermission } from "../../../../shared/components/layout/sidebar/utils/permissions"
import { canShowSaleIntegrationsColumn } from "../lib/can-show-sale-integrations-column.js"
/**
 * @function useSalePermissions
 * @description Hook para verificar permissões de venda
 * @returns {Object} Permissões do usuário para ações de venda
 */
export function useSalePermissions() {
  const permissions = getPermissionsFromStorage()
  return {
    canCreate: hasPermission(permissions, "Vendas", "isinsert"),
    canEdit: hasPermission(permissions, "Vendas", "isinsert"), // Editar geralmente usa isinsert
    canDelete: hasPermission(permissions, "Vendas", "isremove"),
    canList: hasPermission(permissions, "Vendas", "islist"),
    canSend: hasPermission(permissions, "Enviar Vendas", "isinsert"),
    canReopen: hasPermission(permissions, "Reabrir Vendas", "isinsert"),
    canRequestReopen: hasPermission(permissions, "Vendas", "isinsert"),
    canViewIntegrations: canShowSaleIntegrationsColumn(permissions),
  }
}
